<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col>
                <h2 class="my-2">環境センサ一覧</h2>
            </v-col>
            <v-col class="text-right mt-3">
                <v-btn small color="success" @click="openDlgClick(0)"><h3>追加</h3></v-btn>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col cols="12" md="6" lg="4" v-for="obj of dbSensors" :key="obj.id">
                <v-card>
                    <v-toolbar color="indigo" dark>
                        <v-toolbar-title class="font-weight-bold">{{ obj.name }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <h4>管理番号：{{ obj.sort_no }}</h4>
                        <v-chip class="ma-1" color="info" v-show="obj.is_temp">気温センサー</v-chip>
                        <v-chip class="ma-1" color="info" v-show="obj.is_water">水温センサー</v-chip>
                        <v-chip class="ma-1" color="info" v-show="obj.is_solar">日射センサー</v-chip>
                        <v-chip class="ma-1" color="info" v-show="obj.is_oxygen">DOセンサー</v-chip>
                        <v-chip class="ma-1" color="info" v-show="obj.is_salinity">塩分濃度センサー</v-chip>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small color="success" @click="openDlgClick(obj.id)"><h3>編集</h3></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showEditDlg" fullscreen transition="dialog-bottom-transition">
            <v-card color="grey lighten-4">
                <v-toolbar color="indigo" dark>
                    <v-toolbar-title>{{ dlgSensor.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showEditDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="mt-10">
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="4">
                                            <v-text-field label="管理番号" v-model="dlgSensor.sort_no" outlined dense type="number" hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="8">
                                            <v-text-field label="名前" v-model="dlgSensor.name" outlined dense hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col>
                                            <v-switch v-model="dlgSensor.is_temp" label="気温センサー"></v-switch>
                                            <v-switch v-model="dlgSensor.is_water" label="水温センサー"></v-switch>
                                            <v-switch v-model="dlgSensor.is_solar" label="日射センサー"></v-switch>
                                            <v-switch v-model="dlgSensor.is_oxygen" label="DOセンサー"></v-switch>
                                            <v-switch v-model="dlgSensor.is_salinity" label="塩分濃度センサー"></v-switch>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col class="text-center pa-0" v-show="dlgSensor.id > 0">
                            <v-btn color="error" @click="showDelDlg = true" width="100">削除</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="showEditDlg = false" width="100" outlined>キャンセル</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="axiosSubmit()" width="100">登録</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showDelDlg" persistent>
            <v-card>
                <v-toolbar color="indigo" dark>確認</v-toolbar>
                <v-card-title>
                    <h5>「{{ dlgSensor.name }}」を削除してもよろしいですか？</h5>
                </v-card-title>
                <v-card-actions>
                    <v-btn width="100" color="error" class="float-left" @click="axiosDelete()">削除！</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn width="100" color="success" outlined @click="showDelDlg = false">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
export default {
    name: "Sensors",
    data() {
        return {
            jwt: "",
            myInfo: { id: 0, name: "", user_id: 0, site_id: 0 },
            showEditDlg: false,
            showDelDlg: false,
            isLoading: false,
            dbSensors: [],
            dlgSensor: {
                id: 0,
                site_id: 0,
                name: "SENSOR001",
                sort_no: 999,
                is_temp: 0,
                is_water: 0,
                is_solar: 0,
                is_oxygen: 0,
                is_salinity: 0,
            },
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------------------------------
        this.isLoading = true;
        //-----------------------------------------------
        //非同期でAxiosGet
        const promiseFeeder = this.axiosGetSensors();
        //-----------------------
        //上記の終了を待つ
        await promiseFeeder;
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        //-----------------------
        this.isLoading = false;
        window.scrollTo(0, 0);
        //-----------------------------------------------
    },
    //========================================================
    methods: {
        //===================================================
        async axiosGetSensors() {
            await this.axios({
                method: "GET",
                url: "/web/api/sensors",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSensors = response.data.json;
            });
        },
        //===================================================
        // 変更ダイアログ表示
        //===================================================
        openDlgClick(primaryKey) {
            //-----------------------------
            if (primaryKey) {
                for (let obj of this.dbSensors) {
                    if (obj.id == primaryKey) {
                        this.dlgSensor = JSON.parse(JSON.stringify(obj));
                        this.dlgSensor["is_temp"] = !!this.dlgSensor.is_temp;
                        this.dlgSensor["is_water"] = !!this.dlgSensor.is_water;
                        this.dlgSensor["is_solar"] = !!this.dlgSensor.is_solar;
                        this.dlgSensor["is_oxygen"] = !!this.dlgSensor.is_oxygen;
                        this.dlgSensor["is_salinity"] = !!this.dlgSensor.is_salinity;
                    }
                }
            } else {
                this.dlgSensor["id"] = 0;
                this.dlgSensor["name"] = "新規 環境センサ";
                this.dlgSensor["sort_no"] = "100";
                this.dlgSensor["is_temp"] = false;
                this.dlgSensor["is_water"] = false;
                this.dlgSensor["is_solar"] = false;
                this.dlgSensor["is_oxygen"] = false;
                this.dlgSensor["is_salinity"] = false;
                delete this.dlgSensor["modified"];
            }
            this.showEditDlg = true;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosSubmit() {
            let ErrCount = 0;
            if (!this.dlgSensor["name"]) ErrCount++;
            if (!this.dlgSensor["sort_no"]) ErrCount++;
            if (ErrCount) {
                alert("未入力項目があります。");
                return false;
            }
            //-----------------------------------
            this.isLoading = true;
            this.showEditDlg = false;
            //-----------------------------------
            const axiosData = JSON.parse(JSON.stringify(this.dlgSensor));
            axiosData["site_id"] = this.myInfo.site_id;
            axiosData["is_temp"] = axiosData["is_temp"] ? 1 : 0;
            axiosData["is_water"] = axiosData["is_water"] ? 1 : 0;
            axiosData["is_solar"] = axiosData["is_solar"] ? 1 : 0;
            axiosData["is_oxygen"] = axiosData["is_oxygen"] ? 1 : 0;
            axiosData["is_salinity"] = axiosData["is_salinity"] ? 1 : 0;
            delete axiosData["modified"];
            //-----------------------------------
            const primaryKey = this.dlgSensor.id;
            let restMethod = "PUT";
            if (primaryKey == 0) restMethod = "POST";

            let restUrl = "/web/api/sensors";
            if (primaryKey > 0) restUrl = restUrl + "/" + primaryKey;

            await this.axios({
                method: restMethod,
                url: restUrl,
                headers: { Authorization: "Bearer " + this.jwt },
                data: axiosData,
                timeout: 30000,
            })
                .then(() => {
                    this.axiosGetSensors();
                })
                .catch(function (error) {
                    if (error.response.data.err == "ER_DUP_ENTRY") {
                        alert("重複しています。\n保存できません。");
                    } else {
                        alert("ん？ " + error.response.data.err);
                    }
                });
            //-----------------------------------
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosDelete() {
            this.showDelDlg = false;
            this.showEditDlg = false;
            this.isLoading = true;
            //-------------------------
            const PrimaryKey = this.dlgSensor.id;
            await this.axios({
                method: "DELETE",
                url: "/web/api/sensors/" + PrimaryKey,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(() => {
                this.axiosGetSensors();
            });
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
    },
    //========================================================
};
</script>
